import { initiateOAuthLogin } from "@/utils/oauth";
import { OAUTH_LOGIN_REASONS } from "@/utils/oauthTelemetry";
import { FC, useLayoutEffect } from "react";

type TLoginPageProps = {};

/**
 * Login is delegated to irohana center: this page holds no form, it only kicks
 * off the OAuth handoff as soon as it mounts.
 */
export const LoginPage: FC<TLoginPageProps> = () => {
  useLayoutEffect(() => {
    initiateOAuthLogin(OAUTH_LOGIN_REASONS.loginPage);
  }, []);

  return null;
};
